
import React from "react";

const TableColumn = ({ name, value }) => {
    return (
      <>
        <td className="settings-data">{name}</td>
        <td className="settings-data">{value}</td>
      </>
    );
  };
  
  export default TableColumn;